import _ from 'lodash';
import constants from '$$helpers/constants';
import dateHelper from '../../helpers/dateFormatsHelper';
import prepareOptionsForResources from './prepareOptionsForResources';
import getCalcForParent from './getCalcForParent';

const DEFAULT_VALUES_BY_COLUMN_TYPE = {
  [constants.CUSTOM_COLUMNS_TYPES.text.id]: '',
  [constants.CUSTOM_COLUMNS_TYPES.number.id]: 0,
  [constants.CUSTOM_COLUMNS_TYPES.checkbox.id]: 0,
  [constants.CUSTOM_COLUMNS_TYPES.date.id]: '',
  [constants.CUSTOM_COLUMNS_TYPES.resources.id]: '',
};

export default function (result, task, column, taskCustomValue, isBaseline) {
  if (column.options && column.options.length) {
    const taskCustomValueIds = (taskCustomValue || []).map(value => value.task_value);
    const defaultOption = _.find(column.options, opt => opt.is_default);
    const findOption = _.filter(column.options, opt => taskCustomValueIds.includes(opt.id));

    if (findOption.length) {
      result.value = findOption.map(option => option.id).join(',');
      result.toExcel = findOption.map(option => option.value).join('');
    } else if (defaultOption) {
      result.value = `${defaultOption.id}`;
      result.toExcel = defaultOption.value;
    }

    if (column.type === constants.CUSTOM_COLUMNS_TYPES.multiselect.id) {
      const multiSelectText = findOption.map(option => option.value).join(', ');

      result.toExcel = multiSelectText;
      result.preview = findOption;
    }

    if (column.type === constants.CUSTOM_COLUMNS_TYPES.tags.id) {
      result.toExcel = findOption;
      result.preview = findOption;
    }
    if (column.type === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
      const resources = prepareOptionsForResources(findOption, task.gantt_id);

      result.toExcel = resources.map(option => option.value).join(', ');
      result.preview = resources;
    }
  } else {
    let value = taskCustomValue.length ? taskCustomValue.map(value => value.task_value).join('') : DEFAULT_VALUES_BY_COLUMN_TYPE[column.type];

    if (task.type === constants.TASK_TYPES.project && column.type === constants.CUSTOM_COLUMNS_TYPES.number.id) {
      if (column.sub_type === constants.CUSTOM_COLUMNS_SUBTYPES.sum.id) {
        value = getCalcForParent(task, column, isBaseline, true, null);
      }

      if (column.sub_type === constants.CUSTOM_COLUMNS_SUBTYPES.average.id) {
        value = getCalcForParent(task, column, isBaseline, false, null);
      }
    }

    result.value = value;
    result.toExcel = value;

    if (column.type === constants.CUSTOM_COLUMNS_TYPES.checkbox.id) {
      result.value = +value;
      result.toExcel = result.value ? __('common_on') : __('common_off');
    }

    if (column.type === constants.CUSTOM_COLUMNS_TYPES.date.id) {
      const date = value && value !== '0' ? dateHelper.parseDate(value) : DEFAULT_VALUES_BY_COLUMN_TYPE[column.type];

      result.value = date;
      result.toExcel = date;
    }

    if (column.type === constants.CUSTOM_COLUMNS_TYPES.number.id) {
      result.toExcel = (result.value || 0) * 1;
    }
  }

  return result;
}
